import { useDispatch, useSelector } from 'react-redux';

import { type AppDispatch, type RootState } from '@/shared/store/store-factory/store-factory.types';

/**
 * The typed `useDispatch` / `useSelector` every component uses.
 *
 * Both back-edges into the store are `import type` only (W4): this file knows
 * the store's SHAPE and never the store itself, so nothing here can pull the
 * whole reducer graph into a component's bundle or tie a spec to a singleton.
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
